import React from 'react';
import { graphql, useStaticQuery } from 'gatsby';
import { Box } from '@chakra-ui/react';
import { Footer, Header, ScrollToTop } from '@components';

export const Layout = ({ children }) => {
  const { siteSettings } = useStaticQuery(graphql`
    {
      siteSettings: strapiSiteSetting {
        backToTopText
      }
    }
  `);

  return (
    <Box>
      <Header />
      <Box as="main">{children}</Box>
      <Footer />
      {siteSettings?.backToTopText && (
        <ScrollToTop text={siteSettings.backToTopText} />
      )}
    </Box>
  );
};
